
import game from './appTypes/game.png'
import website from './appTypes/globe.png'
import spa from './appTypes/globe.png'
import mobile from './appTypes/mobile.png'
import backend from './appTypes/backend.png'

import reactNative from './frameworks/react-native.svg'

import azureRepo from './repo/azure.png'

import azure from './deployment/azure.png'
import aws from './deployment/aws.png'
import gcp from './deployment/gcp.png'
import heroku from './deployment/heroku.svg'

const images = {
	appTypes: {
		game,
		website,
		spa,
		mobile,
		backend
	},
	frameworks: {
		'react-native': reactNative
	},
	repo: {
		azure: azureRepo
	},
	deployment: {
		azure,
		gcp,
		aws,
		heroku
	}
}

export default images
